import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const usePopUpMembershipStore = create(
  persist(
    set => ({
      popupShown: false,
      status: null,
      setStatus: value => set({ status: value }),
      markPopupShown: () => set({ popupShown: true }),
      resetPopup: () => set({ popupShown: false, status: null }),
    }),
    {
      name: 'membership-popup-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
